module.exports = __webpack_public_path__ + "static/media/strongher14_preview.10f41f78.jpg";